// SXAlert.tsx
import { JSX, useEffect, useRef, useState } from "react";
import { Alert } from "react-bootstrap";
import { SXButton } from "@common/components/ui-components/SXButton";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface SXAlertProps {
  id: string;
  status: number | string | JSX.Element;
  text: string | JSX.Element;
  context?: string;
  varient?: string;
  keep?: boolean;
  offset: number; // injected by container
  onClose: () => void; // dispatch removeAlert
}

export const SXAlert = (props: SXAlertProps) => {
  const [opacity, setOpacity] = useState<number>(1);

  // Keep the latest callback/flag in refs so the fade timer doesn't need to
  // restart every time these props change, while still using fresh values.
  const keepRef = useRef(props.keep);
  const onCloseRef = useRef(props.onClose);
  keepRef.current = props.keep;
  onCloseRef.current = props.onClose;

  useEffect(() => {
    if (keepRef.current) return;

    if (opacity > 0) {
      const timer = setTimeout(() => {
        setOpacity((prev) => Math.max(prev - 0.05, 0));
      }, 108);

      return () => clearTimeout(timer);
    }

    if (opacity <= 0) {
      onCloseRef.current();
    }
  }, [opacity, props.keep]);

  return (
    <Alert
      style={{
        opacity: opacity,
        position: "fixed",
        bottom: `${props.offset}%`,
        right: "1%",
        zIndex: 9999,
      }}
      variant={props.varient}
      id={props.id}
      className="sxalert no-print"
    >
      <SXButton onClick={props.onClose} icon={faTimes} />

      {props.context ? (
        <>
          <strong>{props.status}:</strong> ({props.context}) {props.text}
        </>
      ) : (
        <>
          <strong>{props.status}:</strong> {props.text}
        </>
      )}
    </Alert>
  );
};
